import axios from "../axiosApi";
import { ENROLLMENT_OPERATION, ENROLLMENT_OPERATION_SUCCESS, ENROLLMENT_OPERATION_FAIL } from "../actionTypes";
import { getInstallmentsByPaymentCard } from "./installmentActions";

export const cancelEnrollment = (enrollmentId: number, paymentCard?: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            const response = await axios.post(`/Enrollments/${enrollmentId}/CancelEnrollment`, {});
            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: response.data });
            if (paymentCard) dispatch(getInstallmentsByPaymentCard(paymentCard));
        } catch (e) {
            console.error("cancelEnrollment ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
        }
    }
}

export const evasaoEnrollment = (enrollmentId: number, paymentCard?: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            const response = await axios.post(`/Enrollments/${enrollmentId}/EvasaoEnrollment`, {});
            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: response.data });
            if (paymentCard) dispatch(getInstallmentsByPaymentCard(paymentCard));
        } catch (e) {
            console.error("evasaoEnrollment ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
        }
    }
}

export const reactivateEnrollment = (enrollmentId: number, paymentCard?: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            const response = await axios.post(`/Enrollments/${enrollmentId}/ReativarEnrollment`, {});
            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: response.data });
            if (paymentCard) dispatch(getInstallmentsByPaymentCard(paymentCard));
        } catch (e) {
            console.error("reactivateEnrollment ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
        }
    }
}

export const renegotiateInstallments = (enrollmentId: number, params: {
    fromNumber: number;
    toNumber: number;
    newAmount: number;
    zeroNextOnes: boolean;
}, paymentCard?: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            const response = await axios.post(`/Enrollments/${enrollmentId}/reNegotiateInstallments`, {
                fromNumber: params.fromNumber,
                toNumber: params.toNumber,
                newAmount: params.newAmount,
                zeroNextOnes: params.zeroNextOnes,
                changeAmount: true,
                changeDueDate: false,
                firstDueDate: null
            });
            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: response.data });
            if (paymentCard) dispatch(getInstallmentsByPaymentCard(paymentCard));
        } catch (e) {
            console.error("renegotiateInstallments ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
        }
    }
}

export const addInstallments = (enrollmentId: number, params: {
    amount: number;
    count: number;
    firstDueDate: string;
}, paymentCard?: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            const response = await axios.post(`/Enrollments/${enrollmentId}/addInstallments`, {
                amount: params.amount,
                count: params.count,
                firstDueDate: params.firstDueDate,
            });
            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: response.data });
            if (paymentCard) dispatch(getInstallmentsByPaymentCard(paymentCard));
            return response.data;
        } catch (e) {
            console.error("addInstallments ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
            throw e;
        }
    }
}

/**
 * Update BillingTypeAsaas on enrollment
 * Only sends safe scalar fields - strips relations (enrollmentInLevel) and
 * fixes createdOn date format that MySQL rejects as ER_TRUNCATED_WRONG_VALUE
 */
export const updateEnrollmentBillingType = (enrollment: any, billingType: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            // Strip nested relations and server-managed fields
            const { enrollmentInLevel, createdOn, ...safeFields } = enrollment;
            safeFields.BillingTypeAsaas = billingType;
            const response = await axios.put(`/Enrollments/${enrollment.id}`, safeFields);
            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: response.data });
        } catch (e) {
            console.error("updateEnrollmentBillingType ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
        }
    }
}

/**
 * Send enrollment to ASAAS (external payment service)
 * 1. Creates ASAAS customer ID if not exists (geraIdAsaas)
 * 2. Creates ASAAS subscription (geraAssinaturaAsaas)
 * 3. Refreshes installments
 */
export const enviaParaAsaas = (studentId: number, custAsaasId: string | null, enrollmentId: number, enrollmentPaymentCard: string) => {
    return async (dispatch: any) => {
        dispatch({ type: ENROLLMENT_OPERATION });
        try {
            // 1) Create ASAAS customer if not exists
            if (!custAsaasId || custAsaasId === '') {
                await axios.get(`/Persons/${studentId}/geraIdAsaas`);
            }

            // 2) Create ASAAS subscription
            await axios.get(`/Enrollments/${enrollmentId}/geraAssinaturaAsaas`);

            dispatch({ type: ENROLLMENT_OPERATION_SUCCESS, payload: {} });

            // 3) Refresh installments
            dispatch(getInstallmentsByPaymentCard(String(enrollmentPaymentCard)));
        } catch (e) {
            console.error("enviaParaAsaas ERROR", e);
            dispatch({ type: ENROLLMENT_OPERATION_FAIL, payload: { error: true } });
        }
    }
}
